import { render, staticRenderFns } from "./UpdatePersonalInfoFullName.vue?vue&type=template&id=26729fd2"
import script from "./UpdatePersonalInfoFullName.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalInfoFullName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports